<template>
  <v-container fluid class="pa-6 portafolio-dashboard">
    <div class="d-flex justify-space-between align-center mb-6">
      <h1 class="text-h4 font-weight-bold">Tus Productos</h1>

      <!-- Botón para abrir historial -->
      <v-btn
        class="history-btn"
        outlined
        @click="showHistory = true"
        >
        <v-icon left small>mdi-history</v-icon>
        Ver historial
        </v-btn>
    </div>

    <!-- Productos activos -->
    <v-row dense>
        <v-col
            v-for="item in activePortafolio"
            :key="item.folio"
            cols="12"
            sm="6"
            md="4"
            lg="3"
        >
            <v-card
            class="item-card"
            :class="{ 'overdue-card': item.daysOverDue > 0 }"
            elevation="4"
            hover
            >
            <v-card-text>

                <!-- Header -->
                <div class="d-flex justify-space-between align-center mb-2">
                    <div class="text-h6 font-weight-bold primary--text" :class="{ 'overdue-title': item.daysOverDue > 0 }">
                        {{ item?.product?.name }}
                    </div>
                </div>

                <!-- Si está atrasado -->
                <v-chip
                    v-if="item.daysOverDue > 0"
                    color="red darken-2"
                    text-color="white"
                    small
                    label
                    class="overdue-chip  mb-4"
                >
                    Atrasado {{ item.daysOverDue }} {{ item.daysOverDue === 1 ? 'día' : 'días' }}
                </v-chip>

                <!-- Sin atraso -->
                <v-chip
                    v-else
                    color="weakBlu"
                    text-color="secondary"
                    small
                    label
                    class="font-weight-bold mb-4"
                >
                    Sin atraso
                </v-chip>

                <!-- Folio -->
                <div class="folio-label secondary--text">
                Folio: <strong>{{ item.folio }}</strong>
                </div>

                <!-- Monto -->
                <div class="amount-value secondary--text">
                {{ formatCurrency(item.initialAmount) }} {{ item.currency }}
                </div>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="justify-end">
                <v-btn
                text
                small
                class="details-btn primary--text"
                @click="goToDetail(item.folio)"
                >
                Ver detalle
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-col>

        <ProductHistory :showHistory.sync="showHistory" />
    </v-row>

  </v-container>
</template>

<script>
import ProductHistory from '../components/Modal/ProductHistory.vue'
import productMixin from '../mixins/productMixin'

export default {
  name: 'Portafolio',
  mixins: [productMixin],
  components: { ProductHistory },

  data () {
    return {
      showHistory: false
    }
  },

  async beforeMount () {
    const isLoggedIn = this.$store?.getters?.isLoggedIn

    if (!isLoggedIn) {
      window.location.replace('/login')
    }
  }
}
</script>

<style scoped>
.portafolio-dashboard {
  color: #F5F7FA;
}

.item-card {
  border-radius: 16px !important;
  background: #FFFFFF;
  border: 1px solid #E3E8F1;
  transition: transform .2s ease, box-shadow .2s ease;
}

.item-card:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 26px rgba(0, 0, 0, 0.18) !important;
}

.folio-label {
  font-size: 0.80rem;
  margin-bottom: 6px;
}

.amount-value {
  margin-top: 8px;
  font-size: 1.3rem;
  font-weight: 700;
}

.details-btn {
  font-weight: 600;
  letter-spacing: 0.3px;
}

.overdue-title {
  color: #C62828 !important;
}

.overdue-chip {
  background: #C62828 !important;
  font-weight: bold !important;
}

.history-btn {
  border-color: #AFC2DE !important;
  color: #F5F7FA !important;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 6px 16px !important;
  backdrop-filter: blur(4px);
  transition: all .25s ease;
}

.history-btn:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  border-color: #6E87B8 !important;
}
</style>
